import { extendTheme, type ThemeConfig } from "@chakra-ui/react";
import { button } from "./components/button";
import { checkboxTheme } from "./components/checkbox";
import { switchTheme } from "./components/switch";
import { textStyles } from "./styles";

const availableColorTints = [
  "50",
  "100",
  "200",
  "300",
  "400",
  "500",
  "600",
  "700",
  "800",
  "900",
];

const tokenToColorMap = {
  primary: "blue",
  accent: "teal",
  success: "green",
  warning: "orange",
  error: "red",
  neutral: "gray",
};

const colors = Object.entries(tokenToColorMap).reduce((acc, [token, color]) => {
  availableColorTints.forEach((tint, index) => {
    acc[`${token}.${tint}`] = {
      default: `${color}.${
        availableColorTints[availableColorTints.length - 1 - index]
      }`,
      _dark: `${color}.${tint}`,
    };
  });
  return acc;
}, {});

const config: ThemeConfig = {
  initialColorMode: "light",
  useSystemColorMode: false,
};

const chakraTheme = extendTheme({
  semanticTokens: {
    colors: {
      ...colors,
      brand: "#0F172A",
      // same as brand but colorschemed
      par: {
        "50": "	hsl(222, 47%, 91%)",
        "100": "	hsl(222, 47%, 81%)",
        "200": "	hsl(222, 47%, 61%)",
        "300": "	hsl(222, 47%, 41%)",
        "400": "	hsl(222, 47%, 21%)",
        "500": "	hsl(222, 47%, 11%)",
        "600": "	hsl(222, 47%, 11%)",
        "700": "	hsl(222, 47%, 11%)",
        "800": "	hsl(222, 47%, 7%)",
        "900": "	hsl(222, 47%, 3%)",
      },
      background: {
        default: "#fbfcfe",
        _dark: "#242424",
      },
      foreground: {
        default: "#242424",
        _dark: "#fbfcfe",
      },

      stroke: {
        //   300: "#d2d2df",
        300: " #E4E4EC",
      },
    },
  },
  styles: {
    global: {
      "html, body": {
        color: "foreground",
        bg: "background",
        lineHeight: "tall",
      },
      ".thinSB::-webkit-scrollbar": {
        width: "9px",
        height: "7px",
      },
      ".thinSB::-webkit-scrollbar-thumb": {
        backgroundColor: "sec.200",
        // outline: "1px solid #7489AA",
        borderRadius: "1px",
      },
      ".thinSB::-webkit-scrollbar-track": {
        backgroundColor: "sec.50",
      },
      ".thinSB": {
        scrollbarColor: "#EDEEF2 #FAFCFF",
        scrollbarWidth: "thin",
      },
    },
  },
  fonts: {
    heading: `"Buenos Aires", Inter, system-ui, Avenir, Helvetica, Arial, sans-serif`,
    body: `"Roboto", "Buenos Aires", Inter, system-ui, Avenir, Helvetica, Arial, sans-serif`,
  },
  components: {
    Button: button,
    Switch: switchTheme,
    Checkbox: checkboxTheme,
  },
  textStyles,
  config,
});

export default chakraTheme;
